import lodash from "lodash";
import * as React from "react";
import { useEffect, useMemo, useState } from "react";
import { TextInput } from "../TextInput/TextInput";

const { debounce } = lodash;

const DebouncedInput = React.forwardRef(
  ({ className, value, onChange, debounceTime = 500, type = "text", ...props }, ref) => {
    const [inputValue, setInputValue] = useState(value);

    const debouncedOnChange = useMemo(
      () =>
        debounce((event) => {
          if (onChange) {
            onChange(event);
          }
        }, debounceTime),
      [onChange, debounceTime]
    );

    useEffect(() => {
      setInputValue(value);
    }, [value]);

    useEffect(() => {
      return () => {
        debouncedOnChange.cancel();
      };
    }, [debouncedOnChange]);

    return (
      <input
        type={type}
        className={className}
        ref={ref}
        value={inputValue}
        autoFocus
        onChange={(e) => {
          setInputValue(e.target.value);
          debouncedOnChange(e);
        }}
        aria-label={props["aria-label"] || "Debounced Input"}
        {...props}
      />
    );
  }
);

DebouncedInput.displayName = "DebouncedInput";

export { DebouncedInput };
